import { Union, Record } from "../fable_modules/fable-library-js.4.17.0/Types.js";
import { DataServer_InsiderTrade_InsiderTradeEventPercentage_$reflection, DataServer_InsiderTrade_InsiderTradeEventValuation_$reflection, DataServer_InsiderTrade_InsiderTradeSummary_$reflection } from "../Shared/ApiDataTypes.js";
import { int32_type, obj_type, union_type, record_type, string_type, array_type, option_type } from "../fable_modules/fable-library-js.4.17.0/Reflection.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.17.0/Result.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.17.0/List.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.17.0/MapUtil.js";
import { unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.17.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { DataServerBaseUrl } from "../Components/Constants.js";
import { fromString } from "../fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { int32ToString, comparePrimitives, createObj, uncurry2 } from "../fable_modules/fable-library-js.4.17.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { Dimensions_TextExtraSmall, Dimensions_TextSmall } from "../Components/Design.js";
import { Interop_reactApi } from "../fable_modules/Feliz.2.7.0/Interop.fs.js";
import { useReact_useReducer_2B9E6EA0, useReact_useEffectOnce_3A5B6456, useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.2.7.0/React.fs.js";
import { format, replace } from "../fable_modules/fable-library-js.4.17.0/String.js";
import { boxLoader, assetNameColumn, td$0027, titleHolder, sectionTitle, section } from "./Short.js";
import { sortByDescending, map as map_1 } from "../fable_modules/fable-library-js.4.17.0/Array.js";
import { op_UnaryNegation_Int32 } from "../fable_modules/fable-library-js.4.17.0/Int32.js";
import { LoadingIndicator_skeleton, Tooltip_wrapTooltip } from "../Components/Components.js";
import { Format_shortPercentageToString, Time_utcDateToLocalDate, Format_toShortAmountL, Format_toPercentageChange, Format_toShortAmountKL } from "../Components/Utils.js";
import { singleton, append, delay, toList, toArray } from "../fable_modules/fable-library-js.4.17.0/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.17.0/Range.js";
import { fromInt32, op_Multiply, toInt64 } from "../fable_modules/fable-library-js.4.17.0/BigInt.js";
import { InsiderTradeOverview } from "../Components/Ads.js";

class Model extends Record {
    constructor(Summary, LargestTransactions, LargestPercentages, ErrorMsg) {
        super();
        this.Summary = Summary;
        this.LargestTransactions = LargestTransactions;
        this.LargestPercentages = LargestPercentages;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Investfora.InsiderTrades.Model", [], Model, () => [["Summary", option_type(DataServer_InsiderTrade_InsiderTradeSummary_$reflection())], ["LargestTransactions", option_type(array_type(DataServer_InsiderTrade_InsiderTradeEventValuation_$reflection()))], ["LargestPercentages", option_type(array_type(DataServer_InsiderTrade_InsiderTradeEventPercentage_$reflection()))], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SummaryResponse", "TransactionsResponse", "PercentagesResponse", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Investfora.InsiderTrades.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [DataServer_InsiderTrade_InsiderTradeSummary_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", DataServer_InsiderTrade_InsiderTradeSummary_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(DataServer_InsiderTrade_InsiderTradeEventValuation_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(DataServer_InsiderTrade_InsiderTradeEventValuation_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(DataServer_InsiderTrade_InsiderTradeEventPercentage_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(DataServer_InsiderTrade_InsiderTradeEventPercentage_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], []]);
}

function init() {
    return new Model(undefined, undefined, undefined, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1: {
            const res_1 = msg.fields[0];
            if (res_1.tag === 1) {
                return new Model(model.Summary, model.LargestTransactions, model.LargestPercentages, "Kunne ikke laste største innsidehandler. Vennligst prøv igjen senere.");
            }
            else {
                return new Model(model.Summary, res_1.fields[0], model.LargestPercentages, model.ErrorMsg);
            }
        }
        case 2: {
            const res_2 = msg.fields[0];
            if (res_2.tag === 1) {
                return new Model(model.Summary, model.LargestTransactions, model.LargestPercentages, "Kunne ikke laste største innsidehandler. Vennligst prøv igjen senere.");
            }
            else {
                return new Model(model.Summary, model.LargestTransactions, res_2.fields[0], model.ErrorMsg);
            }
        }
        case 3:
            return new Model(model.Summary, model.LargestTransactions, model.LargestPercentages, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                return new Model(model.Summary, model.LargestTransactions, model.LargestPercentages, "Kunne ikke laste innsidehandel oppsummering. Vennligst prøv igjen senere.");
            }
            else {
                return new Model(res.fields[0], model.LargestTransactions, model.LargestPercentages, model.ErrorMsg);
            }
        }
    }
}

function fetchSummary(dispatch) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let decoder, data_1, caseStrategy_2, extra_2;
        return ((decoder = Auto_generateBoxedDecoder_Z6670B51(DataServer_InsiderTrade_InsiderTradeSummary_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/insider-trade/summary`, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(DataServer_InsiderTrade_InsiderTradeSummary_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))).then((_arg_2) => {
            dispatch(new Message(0, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_1.then();
}

function fetchTransactions(dispatch) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let decoder, data_1, caseStrategy_2, extra_2;
        return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(DataServer_InsiderTrade_InsiderTradeEventValuation_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/insider-trade/largest-transactions?period=14d`, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(DataServer_InsiderTrade_InsiderTradeEventValuation_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))).then((_arg_2) => {
            dispatch(new Message(1, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_1.then();
}

function fetchPercentages(dispatch) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let decoder, data_1, caseStrategy_2, extra_2;
        return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(DataServer_InsiderTrade_InsiderTradeEventPercentage_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/insider-trade/largest-percentage?period=14d`, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(DataServer_InsiderTrade_InsiderTradeEventPercentage_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))).then((_arg_2) => {
            dispatch(new Message(2, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_1.then();
}

function aiInfo() {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        marginTop: 10,
        fontSize: Dimensions_TextSmall,
        fontStyle: "italic",
    }], (elems = [createElement("span", {
        children: ["Denne oppsummeringen er AI-generert fra børsmeldingen. Med forbehold om feil."],
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

function periodIndicator(txt) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        fontSize: Dimensions_TextSmall,
        color: "var(--text-main)",
        marginBottom: 2 + "vh",
        whiteSpace: "nowrap",
    }], (elems = [createElement("span", {
        children: [txt],
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

export class InsiderTradeOmeterEntry extends Record {
    constructor(Ticker, Market, Name, NumTrades, TotalValueKs, NetValueKs) {
        super();
        this.Ticker = Ticker;
        this.Market = Market;
        this.Name = Name;
        this.NumTrades = (NumTrades | 0);
        this.TotalValueKs = (TotalValueKs | 0);
        this.NetValueKs = (NetValueKs | 0);
    }
}

export function InsiderTradeOmeterEntry_$reflection() {
    return record_type("Investfora.InsiderTrades.InsiderTradeOmeterEntry", [], InsiderTradeOmeterEntry, () => [["Ticker", string_type], ["Market", string_type], ["Name", string_type], ["NumTrades", int32_type], ["TotalValueKs", int32_type], ["NetValueKs", int32_type]]);
}

export class InsiderTradeOmeterPercentageEntry extends Record {
    constructor(Ticker, Market, Name, NumTrades, TotalPercentage, NetPercentage, NetValueKs) {
        super();
        this.Ticker = Ticker;
        this.Market = Market;
        this.Name = Name;
        this.NumTrades = (NumTrades | 0);
        this.TotalPercentage = (TotalPercentage | 0);
        this.NetPercentage = (NetPercentage | 0);
        this.NetValueKs = (NetValueKs | 0);
    }
}

export function InsiderTradeOmeterPercentageEntry_$reflection() {
    return record_type("Investfora.InsiderTrades.InsiderTradeOmeterPercentageEntry", [], InsiderTradeOmeterPercentageEntry, () => [["Ticker", string_type], ["Market", string_type], ["Name", string_type], ["NumTrades", int32_type], ["TotalPercentage", int32_type], ["NetPercentage", int32_type], ["NetValueKs", int32_type]]);
}

function Ometer() {
    let elems_3, elems_5, elems_4, value_75;
    const patternInput = useFeliz_React__React_useState_Static_1505("14 d");
    const period = patternInput[0];
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(undefined);
    const setByNet = patternInput_1[1];
    const byNet = patternInput_1[0];
    const fetchByNet = (p) => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            const pd = replace(p, " ", "");
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(InsiderTradeOmeterEntry_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/insider-trade/ometer?period=${pd}`, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(InsiderTradeOmeterEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_2) => {
                const res = _arg_2;
                if (res.tag === 1) {
                    return Promise.resolve();
                }
                else {
                    setByNet(res.fields[0]);
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    };
    useReact_useEffectOnce_3A5B6456(() => {
        fetchByNet(period);
    });
    const periodButton = (p_1) => {
        let elems;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            padding: 3,
            borderRadius: 5,
            cursor: "pointer",
            width: 30,
            textAlign: "center",
        }], ["onClick", (_arg_4) => {
            if (p_1 !== period) {
                setByNet(undefined);
                patternInput[1](p_1);
                fetchByNet(p_1);
            }
        }], (elems = [createElement("span", {
            style: {
                userSelect: "none",
                fontSize: Dimensions_TextSmall,
                borderBottom: (((2 + "px ") + "solid") + " ") + ((p_1 === period) ? "var(--text-main)" : "#f6f6f6"),
            },
            children: p_1,
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
    };
    return section(430, [sectionTitle("Handel-ometer"), createElement("div", createObj(ofArray([["style", {
        display: "grid",
        "grid-template-columns": "repeat(5, 1fr)",
        "grid-template-rows": "repeat(4, 1fr)",
        gap: 5 + "px ",
    }], (elems_3 = ((byNet != null) ? map_1((y_2) => {
        let elems_2, elems_1, y_4;
        return createElement("div", createObj(ofArray([["style", {
            backgroundColor: (y_2.NetValueKs >= 5000) ? "rgb(116, 236, 96)" : ((y_2.NetValueKs >= 0) ? "rgb(166, 256, 146)" : ((y_2.NetValueKs >= op_UnaryNegation_Int32(5000)) ? "rgb(257, 200, 186)" : "rgb(255, 135, 135)")),
            color: "#FFFFFF",
            borderRadius: 4,
            padding: 2,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        }], (elems_2 = [createElement("a", createObj(ofArray([["style", {}], ["href", `/stock/${y_2.Market}/${y_2.Ticker}`], (elems_1 = [Tooltip_wrapTooltip(y_2.Name, createElement("span", {
            style: {
                fontWeight: "bold",
                color: "var(--text-dark)",
            },
            children: `${y_2.Ticker}`,
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), (y_4 = createElement("span", {
            style: {
                fontSize: 0.875 + "rem",
                color: "var(--text-dark)",
            },
            children: Format_toShortAmountKL(y_2.NetValueKs),
        }), Tooltip_wrapTooltip(`Total ${Format_toShortAmountKL(y_2.TotalValueKs)}`, y_4))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
    }, sortByDescending((y) => y.NetValueKs, byNet, {
        Compare: comparePrimitives,
    })) : map_1((_arg_5) => LoadingIndicator_skeleton(ofArray([["minWidth", 76], ["minHeight", 52]])), toArray(rangeDouble(0, 1, 19)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
    }], (elems_5 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
        margin: ((10 + "px ") + 0) + "px",
        border: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
        borderRadius: 5,
        backgroundColor: "#f6f6f6",
        gap: ((0 + "px ") + 5) + "px",
    }], (elems_4 = [periodButton("14 d"), periodButton("1 m"), periodButton("3 m")], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("p", createObj(ofArray([["style", {
        fontSize: Dimensions_TextSmall,
    }], (value_75 = "Topp 20 aksjer, etter total omsetningsverdi av alle innsidehandler i valgt periode, med netto verdi av kjøp mot salg.", ["children", value_75])])))]);
}

function drawSummary(x) {
    const highlightedHolder = (children) => createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            flexBasis: 45 + "%",
            flexGrow: 1,
            flexShrink: 1,
            backgroundColor: "var(--bg-main)",
            borderRadius: 5,
            padding: ((10 + "px ") + 5) + "px",
            gap: 5 + "px ",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
    const highlighted = (title, content, currentValue, prevValue, desc) => {
        let x_2, y, elems_1, elems_2;
        let changeColor;
        const x_1 = currentValue | 0;
        const p = prevValue | 0;
        changeColor = ((x_1 > p) ? "var(--buy)" : ((x_1 < p) ? "var(--sell)" : "var(--text-main)"));
        const pctChange = (prevValue === 0) ? "(0%%)" : (` (${(x_2 = Format_toPercentageChange(currentValue, prevValue), (y = format('{0:' + "0.0" + '}', x_2), (x_2 > 0) ? (`+${y}`) : y))}%)`);
        return highlightedHolder([createElement("span", createObj(ofArray([["style", {
            fontSize: Dimensions_TextSmall,
            color: "var(--text-main)",
        }], (elems_1 = [title, createElement("span", {
            style: {
                color: changeColor,
                fontSize: Dimensions_TextSmall,
            },
            children: pctChange,
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("span", createObj(ofArray([["style", {
            fontWeight: "bold",
            fontSize: 1.2 + "rem",
            whiteSpace: "nowrap",
        }], (elems_2 = [createElement("span", {
            children: [content],
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("span", {
            style: {
                fontSize: Dimensions_TextSmall,
                color: "var(--text-main)",
                whiteSpace: "nowrap",
            },
            children: desc,
        })]);
    };
    const highlightedAsset = (title_1, content_1, desc_1) => highlightedHolder(toList(delay(() => append(singleton(createElement("span", {
        style: {
            fontSize: Dimensions_TextSmall,
            color: "var(--text-main)",
        },
        children: title_1,
    })), delay(() => {
        let elems_3;
        const matchValue = content_1;
        if (matchValue != null) {
            const c = matchValue;
            return append(singleton(createElement("a", createObj(ofArray([["style", {}], ["href", `/stock/${c.Market}/${c.Ticker}`], (elems_3 = [Tooltip_wrapTooltip(c.Name, createElement("span", {
                style: {
                    fontWeight: "bold",
                    fontSize: 1.2 + "rem",
                },
                children: `${c.Ticker}.${c.Market}`,
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => singleton(createElement("span", {
                style: {
                    fontSize: Dimensions_TextSmall,
                    color: "var(--text-main)",
                    whiteSpace: "nowrap",
                },
                children: desc_1(c.Type),
            }))));
        }
        else {
            return append(singleton(createElement("span", {
                style: {
                    fontWeight: "bold",
                },
                children: "N/A",
            })), delay(() => singleton(createElement("span", {
                style: {
                    fontSize: Dimensions_TextSmall,
                    color: "var(--text-main)",
                },
                children: "Ingen for periode",
            }))));
        }
    })))));
    const compNumbers = (c_1, p_2) => {
        const diff = (c_1 - p_2) | 0;
        if (diff === 0) {
            return "Lik forrige periode";
        }
        else {
            return `${diff} ${(diff > 0) ? "over" : "under"} forrige periode`;
        }
    };
    const compValue = (c_2, p_3) => {
        const diff_1 = (c_2 - p_3) | 0;
        if (diff_1 === 0) {
            return "Lik forrige periode";
        }
        else {
            return `${(diff_1 > 0) ? "+" : ""}${Format_toShortAmountL(toInt64(op_Multiply(toInt64(fromInt32(diff_1)), 1000n)))} fra forrige periode`;
        }
    };
    const row$0027 = (children_1) => createElement("div", {
        style: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: 10 + "px ",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children_1)),
    });
    const column$0027 = (children_2) => createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-around",
            flexDirection: "column",
            gap: 10 + "px ",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    });
    const xs_13 = [section(500, toList(delay(() => append(singleton(titleHolder(ofArray([sectionTitle("Oppsummering innsidehandel"), periodIndicator("14 dager")]))), delay(() => {
        const matchValue_1 = x;
        if (matchValue_1 != null) {
            const y_2 = matchValue_1;
            return singleton(column$0027(ofArray([row$0027(ofArray([highlighted("Innsidehandler", int32ToString(y_2.NumTrades), y_2.NumTrades, y_2.PrevNumTrades, compNumbers(y_2.NumTrades, y_2.PrevNumTrades)), highlighted("Estimert verdi", `${Format_toShortAmountL(toInt64(op_Multiply(toInt64(fromInt32(y_2.TotalEstimatedValue)), 1000n)))} NOK`, y_2.TotalEstimatedValue, y_2.PrevTotalEstimatedValue, compValue(y_2.TotalEstimatedValue, y_2.PrevTotalEstimatedValue))])), row$0027(ofArray([highlighted("Innsidekjøp", int32ToString(y_2.NumBought), y_2.NumBought, y_2.PrevNumBought, compNumbers(y_2.NumBought, y_2.PrevNumBought)), highlighted("Estimert kjøpt", `${Format_toShortAmountL(toInt64(op_Multiply(toInt64(fromInt32(y_2.TotalEstimatedValueBought)), 1000n)))} NOK`, y_2.TotalEstimatedValueBought, y_2.PrevTotalEstimatedValueBought, compValue(y_2.TotalEstimatedValueBought, y_2.PrevTotalEstimatedValueBought))])), row$0027(ofArray([highlighted("Innsidesalg", int32ToString(y_2.NumSold), y_2.NumSold, y_2.PrevNumSold, compNumbers(y_2.NumSold, y_2.PrevNumSold)), highlighted("Estimert solgt", `${Format_toShortAmountL(toInt64(op_Multiply(toInt64(fromInt32(y_2.TotalEstimateValueSold)), 1000n)))} NOK`, y_2.TotalEstimateValueSold, y_2.PrevTotalEstimatedValueSold, compValue(y_2.TotalEstimateValueSold, y_2.PrevTotalEstimatedValueSold))]))])));
        }
        else {
            return singleton(LoadingIndicator_skeleton(ofArray([["minWidth", 220], ["width", 100 + "%"], ["minHeight", 210]])));
        }
    }))))), section(500, toList(delay(() => append(singleton(titleHolder(ofArray([sectionTitle("Topplisten"), periodIndicator("14 dager")]))), delay(() => {
        const matchValue_2 = x;
        if (matchValue_2 != null) {
            const y_3 = matchValue_2;
            return singleton(column$0027(ofArray([row$0027(ofArray([highlightedAsset("Flest handler", y_3.MostTrades, (n) => (`${n} kjøp og salg`)), highlightedAsset("Størst handelsverdi", y_3.HighestTradeValue, (n_1) => (`${Format_toShortAmountL(toInt64(op_Multiply(toInt64(fromInt32(n_1)), 1000n)))} NOK kjøpt og solgt`))])), row$0027(ofArray([highlightedAsset("Flest kjøp", y_3.MostBoughtByNum, (n_2) => (`${n_2} innsidekjøp`)), highlightedAsset("Størst kjøpsverdi", y_3.MostBoughtByValue, (n_3) => (`${Format_toShortAmountL(toInt64(op_Multiply(toInt64(fromInt32(n_3)), 1000n)))} NOK kjøpt`))])), row$0027(ofArray([highlightedAsset("Flest salg", y_3.MostSoldByNum, (n_4) => (`${n_4} innsidesalg`)), highlightedAsset("Størst salgsverdi", y_3.MostSoldByValue, (n_5) => (`${Format_toShortAmountL(toInt64(op_Multiply(toInt64(fromInt32(n_5)), 1000n)))}NOK solgt`))]))])));
        }
        else {
            return singleton(LoadingIndicator_skeleton(ofArray([["minWidth", 220], ["width", 100 + "%"], ["minHeight", 210]])));
        }
    })))))];
    return react.createElement(react.Fragment, {}, ...xs_13);
}

function dateBoughtColumn(x) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        userSelect: "none",
    }], (elems = [createElement("span", {
        style: {
            fontWeight: "bold",
        },
        children: `${Time_utcDateToLocalDate(x)}`,
    }), createElement("span", {
        style: {
            fontSize: Dimensions_TextExtraSmall,
        },
        children: "Dato meldt",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

function drawLargestTransactions(x) {
    return section(470, toList(delay(() => append(singleton(titleHolder(ofArray([sectionTitle("Største handler etter estimert verdi"), periodIndicator("14 dager")]))), delay(() => {
        let matchValue, children_4, children_2;
        return append((matchValue = x, (matchValue != null) ? singleton((children_4 = singleton_1((children_2 = map_1((z_1) => {
            let elems;
            const children = ofArray([td$0027([assetNameColumn(z_1.Ticker, z_1.Market, z_1.Name)]), td$0027([createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                userSelect: "none",
            }], (elems = [createElement("span", {
                style: {
                    fontWeight: "bold",
                },
                children: Format_toShortAmountL(toInt64(op_Multiply(toInt64(fromInt32(z_1.EstValueKs)), 1000n))),
            }), createElement("span", {
                style: {
                    fontSize: Dimensions_TextExtraSmall,
                },
                children: "NOK",
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))]), td$0027([dateBoughtColumn(z_1.Date)])]);
            return createElement("tr", {
                children: Interop_reactApi.Children.toArray(Array.from(children)),
            });
        }, sortByDescending((z) => {
            if (z.EstValueKs < 0) {
                return (z.EstValueKs * -1) | 0;
            }
            else {
                return z.EstValueKs | 0;
            }
        }, matchValue, {
            Compare: comparePrimitives,
        })), createElement("tbody", {
            children: Interop_reactApi.Children.toArray(Array.from(children_2)),
        }))), createElement("table", {
            children: Interop_reactApi.Children.toArray(Array.from(children_4)),
        }))) : singleton(boxLoader(488))), delay(() => singleton(aiInfo())));
    })))));
}

function drawLargestPercentages(x) {
    return section(470, toList(delay(() => append(singleton(titleHolder(ofArray([sectionTitle("Største handler andel av utestående aksjer"), periodIndicator("14 dager")]))), delay(() => {
        let matchValue, children_4, children_2;
        return append((matchValue = x, (matchValue != null) ? singleton((children_4 = singleton_1((children_2 = map_1((z_1) => {
            let elems;
            const children = ofArray([td$0027([assetNameColumn(z_1.Ticker, z_1.Market, z_1.Name)]), td$0027([createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                userSelect: "none",
            }], (elems = [createElement("span", {
                style: {
                    fontWeight: "bold",
                },
                children: Format_shortPercentageToString(z_1.Percentage),
            }), createElement("span", {
                style: {
                    fontSize: Dimensions_TextExtraSmall,
                },
                children: "Av utestående",
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))]), td$0027([dateBoughtColumn(z_1.Date)])]);
            return createElement("tr", {
                children: Interop_reactApi.Children.toArray(Array.from(children)),
            });
        }, sortByDescending((z) => {
            if (z.Percentage < 0) {
                return (z.Percentage * -1) | 0;
            }
            else {
                return z.Percentage | 0;
            }
        }, matchValue, {
            Compare: comparePrimitives,
        })), createElement("tbody", {
            children: Interop_reactApi.Children.toArray(Array.from(children_2)),
        }))), createElement("table", {
            children: Interop_reactApi.Children.toArray(Array.from(children_4)),
        }))) : singleton(boxLoader(488))), delay(() => singleton(aiInfo())));
    })))));
}

export function InsiderTrades() {
    let elems_4, elems, elems_1, elems_3, elems_2;
    const patternInput = useReact_useReducer_2B9E6EA0(update, init());
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    useReact_useEffectOnce_3A5B6456(() => {
        fetchSummary(dispatch);
        fetchTransactions(dispatch);
        fetchPercentages(dispatch);
    });
    return createElement("div", createObj(ofArray([["className", "default-gap"], ["style", {
        display: "flex",
        flexDirection: "column",
        padding: 1 + "vw",
    }], (elems_4 = [createElement("div", createObj(ofArray([["className", "default-gap"], ["style", {
        display: "flex",
        flexWrap: "wrap",
    }], (elems = [createElement(Ometer, null), drawSummary(model_1.Summary)], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "default-gap"], ["style", {
        display: "flex",
        flexWrap: "wrap",
    }], (elems_1 = [drawLargestTransactions(model_1.LargestTransactions), drawLargestPercentages(model_1.LargestPercentages)], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        width: 100 + "%",
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
        maxWidth: 1200,
    }], (elems_2 = [createElement(InsiderTradeOverview, null)], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
}

